/** 
 * Copyright (c) Open Carbon, 2020
 * 
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * reducers/initializers.js 
 * 
 * react-redux reducer initializers
 */ 


// Set up initial state of some global variables using constants
export const initialStateGlobal = {
    mapref: null,
    currentlat: null,
    currentlng: null,
    geojson: null,
    centre: null,
    zoom: null,
    projecttypes: {
        "stage-0": true,
        "stage-1": true,
        "stage-2": true,
        "stage-3": true,
        "stage-4": true,
        "stage-5": true,
        "stage-6": true
    },
};
